import {useMemo} from 'react'
import {useTable} from 'react-table'
import {
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
} from './core/QueryResponseProvider'
import {fields} from './core/_models'
import {QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from './core/ListViewProvider'
import {useQueryRequest} from './core/QueryRequestProvider'
import {deleteBlog, updateBlog} from './core/_requests'
import {cells} from '../../../../../_component/table/Cell'
import {KTable} from '../../../../../_component/table/Table'

export const Table = () => {
  const pagination = useQueryResponsePagination()
  const {state, updateState} = useQueryRequest()
  const {refetch} = useQueryResponse()
  const {setItemIdToView, setItemIdForUpdate, isAllSelected, onSelectAll, selected, onSelect} =
    useListView()
  const blogs = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => blogs, [blogs])
  const columns = useMemo(
    () =>
      cells({
        model: QUERIES.BLOG_LIST,
        fields: fields.filter((field) => field.table),
        state,
        updateState,
        updateAction: updateBlog,
        deleteAction: deleteBlog,
        setItemIdToView,
        setItemIdForUpdate,
        refetch,
        isAllSelected,
        onSelectAll,
        selected,
        onSelect,
        selectAble: true,
        actionAble: true,
      }),
    // eslint-disable-next-line
    [state, onSelectAll]
  )
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTable
      headers={headers}
      rows={rows}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
      prepareRow={prepareRow}
      setItemIdToView={setItemIdToView}
      isLoading={isLoading}
      pagination={pagination}
      updateState={updateState}
    />
  )
}
